import { tryParseInt } from '@witkac/utils/tryParseInt';
import { Route } from 'vue-router';

import { baseFilters } from './baseFilters';
import { LocalStorage } from '@/enums/storage.enum';

/**
 * Filtry historii użyć karty
 *
 * @export
 * @param {Route} route
 * @returns
 */
export function historyFilters(route: Route) {
  return {
    order: 'created',
    desc: true,
    ...baseFilters(route, 16),
    profileId: tryParseInt(localStorage.getItem(LocalStorage.PROFILE_ID) as string)
  };
}
